import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'tag-input',//组件引用的名称
    template: `<div class="father_box input_required" [ngClass]="{'input_required':inputData.length==0 && required,'input_required_true':inputData.length!=0 && required}">
      <div class="spanBox" *ngFor="let item of inputData; let i = index;">
        <span class="tagspan">{{item}}</span>
        <i class="span_close" (click)="removeTag(i,item)"></i>
      </div>
      <input type="text" [name]="name" class="form-control inputTag" placeholder="Please enter..." [(ngModel)]="keyupData"  />
    </div>`,
  styles: [`
    .father_box {
        box-sizing:border-box;
        background-color: white;
        border: 1px solid #dcdee2;
        font-size: 12px;
        text-align: left;
        word-wrap: break-word;
        overflow: hidden;
    }
    .input_required{
      border-left: 3px solid #a94442;
    }
    .input_required_true{
      border-left: 3px solid #42a948;
    }
    .spanBox {
        display: inline-block;
        font-size: 14px;
        margin: 3px 4px;
        background-color: rgb(229,229,229);
        border: 1px solid #e8eaec;
        border-radius: 3px;
    }
    .tagspan {
        height: 24px;
        line-height: 22px;
        max-width: 99%;
        position: relative;
        display: inline-block;
        padding-left: 8px;
        color: #495060;
        font-size: 14px;
        cursor: pointer;
        opacity: 1;
        vertical-align: middle;
        overflow: hidden;
        transition: 0.25s linear;
        color: rgb(26, 26, 26);
        font-weight: 600;}.span_close {
        padding: 0 4px 0 4px;
        opacity: 1;
        -webkit-filter: none;
        filter: none;
        color: rgb(26, 26, 26);
        font-weight: 600;
    }
    .span_close:after {
        content: "×";
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        /* line-height: 27px; */
        transition: .3s,color 0s;
    }
    .inputTag {
        font-size: 16px;
        border: none;
        box-shadow: none;
        outline: none;
        background-color: transparent;
        width: 100%;
        min-width: 250px;
        vertical-align: top;
        height: 32px;
        color: #495060;
        line-height: 20px;
        font-size: 14px;
        padding: 6px 12px;}
    `] 
})
export class TagInputComponent implements OnInit {
  constructor() { }
  public keyupData = ''
  //获取父类的变量值
  @Input() inputData: any = [];
  @Input() name: any = '';
  @Input() required: any = '';
  @Input() modelData: any = '';
  @Output() inputDataChange: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit(): void {
  }
  
  public keyup(val): void { 
    this.inputData.push(val)
    this.keyupData = ''
    this.transitionData()
    // this.inputDataChange.emit(this.inputData);
  }
  private removeTag(index,value):void { 
    this.inputData.splice(index,1)
    this.transitionData()
    // this.inputDataChange.emit(this.inputData);
  }
  private transitionData(): void{
    let emitData = ''
    for (let i = 0; i < this.inputData.length; i++) { 
      emitData += this.inputData[i] + (i < this.inputData.length -1? ',' : '')
    }
    this.inputDataChange.emit(emitData);
  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/service/tag-input.ts